












document.addEventListener("DOMContentLoaded", function () {
  // Select all links inside elements with class 'header-logo header-logo--image' that have href="/"
  const logoLinks = document.querySelectorAll('.header-logo.header-logo--image a[href="/"]');

  logoLinks.forEach(link => {
    // === Change the destination URL ===
    link.href = 'https://beambright.shop/pages/home';

    // === Optional: log change confirmation in the console ===
    console.log('Updated logo link:', link.href);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Target all <a> elements
  const allLinks = document.querySelectorAll('a[href^="https://beambright.shop/pages/home"]');

  allLinks.forEach(link => {
    // Replace the href value with your new PageFly URL
    link.href = 'https://beambright.shop/pages/home';
    
    // Optional: open in the same tab (or use '_blank' for new tab)
    link.target = '_self';

    // Optional console log confirmation
    console.log('Updated link to PageFly:', link);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Redirect only if visitor is on homepage
  if (window.location.pathname === "/" || window.location.pathname === "/index.html") {
    window.location.href = "https://beambright.shop/pages/home";
  }
});




